module.exports = __webpack_public_path__ + "static/media/builtinv2-domashniy_kinozal_toxmedia_k2 1.25ea052b.png";